import { useAssetActionModalStore } from '@/store/asset-action-modal.store';
import ListView, { ListViewItem } from '@ingka/list-view';
import { selectCurrencyCode } from '@repo/api-adapters/selectors/customer-assets.selectors';
import { translate } from '@repo/phrase';

import { MODAL } from '@/components/modals/asset-modal.types';

import { useSalesPersonDiscounts } from '@/hooks/asset-price-discounts.hooks';
import { useUniqueSavings } from '@/hooks/asset-price-savings.hooks';
import { useAsset, useAssetParams } from '@/hooks/asset.hooks';
import { formatPrice } from '@/utils/translation.utils';

export const AssetPriceSummaryLink = () => {
    const { assetType, assetId } = useAssetParams();
    const { data } = useAsset(assetType, assetId);
    const setActiveModal = useAssetActionModalStore((state) => state.setActiveModal);
    const savings = useUniqueSavings();
    const { discountListTotal } = useSalesPersonDiscounts();
    const currencyCode = selectCurrencyCode(data);
    const totalSavingsValue = savings.reduce((acc, curr) => acc + curr.savingValue, 0) + discountListTotal;

    const description = totalSavingsValue
        ? `${translate('asset_price_savings')}: ${formatPrice(totalSavingsValue, currencyCode)}`
        : undefined;

    return (
        <ListView id="asset-price-summary-link" showDivider={false} size="medium">
            <ListViewItem
                control="navigational"
                controlIcon="chevronRight"
                description={description}
                emphasised
                onClick={() => {
                    setActiveModal(MODAL.PRICE_SUMMARY);
                }}
                title={<strong>{translate('asset_price_summary')}</strong>}
            />
        </ListView>
    );
};
